import { Component } from 'react'
import * as Aviator from 'aviator'
import { DispatchProp } from 'react-redux'
import { AnyAction } from 'redux'

export abstract class Routable<
  P extends DispatchProp<AnyAction> = DispatchProp<AnyAction>,
  S = {}
> extends Component<P, S> {
  protected navigate(routeName: string, queryParams?: {}, replaceBase?: boolean): void {
    Aviator.navigate(`${replaceBase ? '/' : ''}${routeName}`, { queryParams })
  }

  protected reset(routeName: string, queryParams?: {}, replaceBase?: boolean): void {
    Aviator.navigate(`${replaceBase ? '/' : ''}${routeName}`, { replace: true, queryParams })
  }

  protected isURIActive(uri: string): boolean {
    const currentURI = Aviator.getCurrentURI()
    return uri === currentURI.slice(1)
  }
}
